export default "__VITE_ASSET__8edjpOXB__"